<template>
  <s-form
    ><s-form-actions slot="actions" class="clearfix">
      <sf-button
        slot="left"
        style="float: left; padding: 3px 0"
        type="text"
        material="close"
        @click="$emit('close', valueData)"
      ></sf-button>
      <sf-button
        style="float: right; padding: 3px 0"
        xtype="text"
        material="save"
        @click="
          $emit('input', valueData);
          $emit('change', valueData);
        "
      ></sf-button>
    </s-form-actions>
    <s-form-item
      v-for="(colprops, idx) in colDefinitions"
      :key="idx"
      :label="colprops.label"
    >
      <template v-if="colprops.editable !== false">
        <component
          :is="colprops.editorcomponent.is"
          v-if="colprops.editorcomponent"
          v-bind="colprops.editorcomponent"
          v-model="valueData[colprops.prop]"
          :col-definion="colprops"
        ></component>

        <el-input v-else v-model="valueData[colprops.prop]">
          <!-- <template slot="prepend">{{ colprops.label }}</template> -->
        </el-input>
      </template>
      <span
        v-else
        v-html="displayVal(valueData[colprops.prop], colprops, valueData)"
      >
      </span>
    </s-form-item>
  </s-form>
</template>

<script>
import * as moment from "moment";
import SFormActions from "./SFormActions.vue";

export default {
  components: { SFormActions },
  name: "s-auto-form",

  props: {
    displayValProcessor: {
      type: Function,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    value: { default: null },
    colDefinitions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return { valueData: null };
  },
  computed: {
    parsedVal() {
      // var out = this.value;
      // // _log_("CCC..", this.type);
      // if (this.type == "date") out = moment.unix(out).format("DD/MM/YYYY");
      // return out;
    },
  },
  methods: {
    stopclick(e) {
      _log_("CCC alter..", e);
      e.preventDefault();
      e.stopPropagation();
    },
    handleAlter(e) {
      this.$emit("execute", { alterClick: true, ...e });
    },
    displayVal(val, colDefs, row) {
      var out = val;
      if (this.displayValProcessor)
        return this.displayValProcessor(val, colDefs, row);
      return out;
    },
  },
  watch: {
    // value: {
    //   async handler(v, o) {
    //     this.valueData = v;
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
  created() {
    // _log_("chll..clk...", this.colprops);
    this.valueData = this.value;
  },
};
</script>
<style >
.hover-redirect {
  z-index: 20;
  position: absolute;
  left: 2px;
  top: 2px;
}
</style>